import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

const TutorialMessage = ({ message }) => (
  <div className="tutorial--message" style={{ zIndex: '100' }}>
    <div className="tutorial--message__img"></div>
    <span>
      <div style={{ paddingLeft: '100px' }}>
        <FormattedMessage id={message} defaultMessage={message} />
      </div>
    </span>
  </div>
)

TutorialMessage.propTypes = {
  message: PropTypes.string,
}
export default injectIntl(TutorialMessage)
